/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { DateSearch } from './DateSearch';
import {
    DateSearchFromJSON,
    DateSearchFromJSONTyped,
    DateSearchToJSON,
} from './DateSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface FormateurHoraireSearch
 */
export interface FormateurHoraireSearch {
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireSearch
     */
    idformateur?: number | null;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurHoraireSearch
     */
    annee?: TextSearch;
    /**
     * 
     * @type {DateSearch}
     * @memberof FormateurHoraireSearch
     */
    date?: DateSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurHoraireSearch
     */
    classe?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurHoraireSearch
     */
    matiere?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurHoraireSearch
     */
    nom?: TextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof FormateurHoraireSearch
     */
    local?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof FormateurHoraireSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof FormateurHoraireSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof FormateurHoraireSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof FormateurHoraireSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the FormateurHoraireSearch interface.
 */
export function instanceOfFormateurHoraireSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurHoraireSearchFromJSON(json: any): FormateurHoraireSearch {
    return FormateurHoraireSearchFromJSONTyped(json, false);
}

export function FormateurHoraireSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurHoraireSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idformateur': !exists(json, 'idformateur') ? undefined : json['idformateur'],
        'annee': !exists(json, 'annee') ? undefined : TextSearchFromJSON(json['annee']),
        'date': !exists(json, 'date') ? undefined : DateSearchFromJSON(json['date']),
        'classe': !exists(json, 'classe') ? undefined : TextSearchFromJSON(json['classe']),
        'matiere': !exists(json, 'matiere') ? undefined : TextSearchFromJSON(json['matiere']),
        'nom': !exists(json, 'nom') ? undefined : TextSearchFromJSON(json['nom']),
        'local': !exists(json, 'local') ? undefined : TextSearchFromJSON(json['local']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function FormateurHoraireSearchToJSON(value?: FormateurHoraireSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idformateur': value.idformateur,
        'annee': TextSearchToJSON(value.annee),
        'date': DateSearchToJSON(value.date),
        'classe': TextSearchToJSON(value.classe),
        'matiere': TextSearchToJSON(value.matiere),
        'nom': TextSearchToJSON(value.nom),
        'local': TextSearchToJSON(value.local),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

